export default { accessToken: 'cd3233a31f0a8217d9c58299ee116850d3cfdae7d7f54f56fab27e28587d6702' }
